/** Cartoon emoji avatars offered on the home page (24, picker grid of 8×3 or 6×4). */
export const AVATARS = [
  '🐶',
  '🐱',
  '🦊',
  '🐻',
  '🐼',
  '🐨',
  '🐯',
  '🦁',
  '🐮',
  '🐷',
  '🐸',
  '🐵',
  '🐰',
  '🐺',
  '🐧',
  '🦉',
  '🐙',
  '🦄',
  '🐲',
  '🦖',
  '👽',
  '👻',
  '🤠',
  '😎',
] as const;

export type AvatarEmoji = (typeof AVATARS)[number];

/** Deterministic default avatar for a name (stable across reloads). */
export function defaultAvatar(seed: string): AvatarEmoji {
  let h = 0;
  for (const ch of seed) h = (h * 31 + (ch.codePointAt(0) ?? 0)) >>> 0;
  return AVATARS[h % AVATARS.length]!;
}
